// extracted by mini-css-extract-plugin
export default {"modalStyle":"PublisherFormModal_modalStyle__Pl3AT"};